import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Salesperson } from '@galaxy/types';
import { AccountUrlFunction, OpportunityUrlFunction } from '../../sales-opportunities/opportunity';

export const PIPELINE_TABLE_SERVICE_CONFIG_TOKEN = new InjectionToken<PipelineTableServiceConfig>(
  'general dependency data for the pipeline table',
);

export interface PipelineTableServiceConfig {
  getOpportunityDetailsUrl?: OpportunityUrlFunction;
  getAccountDetailsUrl?: AccountUrlFunction;
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  defaultCurrency$: Observable<string>;
  allSalespeople$: Observable<Salesperson[]>;
}

export const ALL_SALESPEOPLE_TOKEN: InjectionToken<Observable<Salesperson[]>> = new InjectionToken(
  'token for all salespeople',
);
export const DEFAULT_CURRENCY_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  'token for default currency',
);
export const OPPORTUNITY_DETAILS_URL_TOKEN: InjectionToken<OpportunityUrlFunction> = new InjectionToken(
  'token for opportunity details URL generator',
);
export const ACCOUNT_DETAILS_URL_TOKEN: InjectionToken<AccountUrlFunction> = new InjectionToken(
  'token for account details URL generator',
);
